import { useCallback, useState } from 'react';
import { DateSelector, MoreCalculators, Result } from '../../components';
import { getDaysYouLived } from '../../utils';
import './DaysYouLived.scss';

export const DaysYouLived = () => {
  const [dateOfBirth, setDateOfBirth] = useState(() => new Date('1990-01-01'));
  const [daysYouLived, setDaysYouLived] = useState(() =>
    getDaysYouLived(dateOfBirth)
  );
  const [showLoader, setShowLoader] = useState(false);

  const calculate = useCallback(() => {
    setShowLoader(true);
    setDaysYouLived(() => getDaysYouLived(dateOfBirth));
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }, [dateOfBirth]);

  return (
    <>
      <div className='page p-4 rounded border mb-5'>
        <h2>Days You Lived Calculator</h2>
        <p className='mb-4'>Calculate how many days you have lived so far</p>
        <section className='input border rounded p-4 mb-5'>
          <DateSelector
            label='Select Your Date of Birth'
            initDate={dateOfBirth}
            setDate={setDateOfBirth}
            maxDate={new Date()}
          />
          <button
            className='btn btn-success d-block w-100 py-2 fw-bold'
            onClick={calculate}
          >
            Calculate
          </button>
        </section>
        <Result showLoader={showLoader}>
          <>
            <h4>Answer:</h4>
            <p
              className='mb-0'
              dangerouslySetInnerHTML={{ __html: daysYouLived }}
            />
          </>
        </Result>
      </div>
      <MoreCalculators />
    </>
  );
};
